import { VL_API_BASE_URL } from '../constants/backendUrls';
import type { IdentityProvider, TenantInfo, UserInfo, UserPool, UserPermission } from '../types/auth';
import { APIClient } from './apiClient';

const tenantUrl = `${VL_API_BASE_URL}/tenant`;
const tenantIdentityProviderUrl = `${tenantUrl}/idp`;


async function getUser () {
    return await APIClient<UserInfo>(`${VL_API_BASE_URL}/users/me`);
}

async function getUserPermissions () {
    return await APIClient<UserPermission>(`${VL_API_BASE_URL}/users/me/permissions`);
}

async function getUserPool (tenantAlias: string) {
    // @ts-ignore
    return await $fetch<UserPool>(`${VL_API_BASE_URL}/userpool/${tenantAlias}`);
}

async function getTenantInfo () {
    return await APIClient<TenantInfo>(tenantUrl);
}
async function updateTenantInfo (tenantData: Partial<TenantInfo>) {
    return await APIClient<TenantInfo>(`${tenantUrl}/`, {
        method: 'PATCH',
        body: JSON.stringify(tenantData)
    });
}

async function getTenantIdentityProviders () {
    return await APIClient<IdentityProvider[]>(tenantIdentityProviderUrl);
}

async function getTenantIdentityProvider (providerName: string) {
    return await APIClient<IdentityProvider>(`${tenantIdentityProviderUrl}/${encodeURIComponent(providerName)}`);
}

async function createTenantIdentityProvider (identityProvider: IdentityProvider) {
    return await APIClient(`${tenantIdentityProviderUrl}`, {
        method: 'POST',
        body: JSON.stringify(identityProvider)
    });
}

async function updateTenantIdentityProvider (providerName: string, identityProvider: Partial<IdentityProvider>) {
    return await APIClient(`${tenantIdentityProviderUrl}/${encodeURIComponent(providerName)}`, {
        method: 'PATCH',
        body: JSON.stringify(identityProvider)
    });
}

async function deleteTenantIdentityProvider (providerName: string) {
    return await APIClient(`${tenantIdentityProviderUrl}/${encodeURIComponent(providerName)}`, {
        method: 'DELETE'
    });
}

export {
    getUser,
    getUserPermissions,
    getUserPool,
    getTenantInfo,
    updateTenantInfo,
    getTenantIdentityProviders,
    getTenantIdentityProvider,
    createTenantIdentityProvider,
    updateTenantIdentityProvider,
    deleteTenantIdentityProvider
};
